import type { ShowCostsOnMobile } from '@cencosud-cencommerce/paris-uikit/dist/organisms/PurchaseSummary/PurchaseSummary';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { TPaymentMethodId } from '@/modules/perseo-billing/components/accordion/interfaces';
import { useGiftCardData } from '@/modules/perseo-billing/hooks';
import { isWeddingFlow } from '@/modules/shared/utils/isWeddingFlow';

const { EPAY_TCOM, EPAY_CENCOSUD_TCOM, GIFT_CARD, WEBPAY, CENCOPAY } =
  TPaymentMethodId;

const DEFAULT_COSTS = {
  showTotalPrice: true,
  showTotalPriceCenco: true
};

const WEDDING_COSTS = {
  showShippingTotal: false,
  showProductsCost: true
};

const SHOW_CENCOPAY_COST = {
  showTotalPriceCencoPay: true
};

const SHOW_TOTAL_PRICE_COST = {
  showTotalPrice: true
};

const isWedding = isWeddingFlow();

export const useGetCostsOnMobile = () => {
  const billing = useAppSelector((state) => state.billing);
  const cartPayments = useAppSelector((state) => state.cartPayments.data);

  const { cartHasGiftCardPayment, canGiftCardPayTotalAmount } =
    useGiftCardData();
  const hasGiftCard = cartHasGiftCardPayment();
  const giftCardCanPayTotalAmount = canGiftCardPayTotalAmount();

  const accordionMethodId = billing.activeAccordion?.accordionPaymentMethodId;
  const currentMethodId = accordionMethodId as TPaymentMethodId;

  const getCostsOnMobile = (): ShowCostsOnMobile => {
    if (isWedding) return WEDDING_COSTS;

    if (currentMethodId === GIFT_CARD) {
      if (!hasGiftCard) return SHOW_TOTAL_PRICE_COST;

      if (!giftCardCanPayTotalAmount) {
        return {
          ...SHOW_TOTAL_PRICE_COST,
          showAppliedGiftCard: true
        };
      }

      return {
        showGiftCardTotal: true
      };
    }

    const otherPaymentMethods = [EPAY_TCOM, GIFT_CARD, WEBPAY];
    if (otherPaymentMethods.includes(currentMethodId)) {
      return {
        ...SHOW_TOTAL_PRICE_COST,
        showAppliedGiftCard: hasGiftCard && !giftCardCanPayTotalAmount,
        showGiftCardTotal: giftCardCanPayTotalAmount
      };
    }

    if (currentMethodId === EPAY_CENCOSUD_TCOM) {
      if (!hasGiftCard) {
        return {
          showTotalPriceCenco: true
        };
      }

      if (!giftCardCanPayTotalAmount) {
        return {
          showTotalPriceCenco: true,
          showAppliedGiftCard: true
        };
      }

      return {
        showTotalPriceCenco: true,
        showAppliedGiftCard: hasGiftCard && !giftCardCanPayTotalAmount,
        showGiftCardTotal: giftCardCanPayTotalAmount
      };
    }

    if (currentMethodId === CENCOPAY) return SHOW_CENCOPAY_COST;

    const cencoPayCent = cartPayments?.cencoPay?.centAmount ?? 0;
    const cencosudCardCent = cartPayments?.cencosudCard?.centAmount ?? 0;

    if (cencoPayCent < cencosudCardCent) {
      return {
        ...SHOW_TOTAL_PRICE_COST,
        showTotalPriceCencoPay: true
      };
    }

    if (cencosudCardCent < cencoPayCent) {
      return {
        ...SHOW_TOTAL_PRICE_COST,
        showTotalPriceCenco: true
      };
    }

    return DEFAULT_COSTS;
  };

  return { getCostsOnMobile };
};
